<script setup>
import { computed } from 'vue';
import MarkdownIt from 'markdown-it';
import '@garmin/components-global-web/dist-web/components/GCopy';

const markdownIt = new MarkdownIt({ breaks: true });

/* Props */
const props = defineProps({
  content: {
    type: String,
    default: '',
  },
});

/* Computed */
const markDownCopy = computed(() => markdownIt.renderInline(props.content));
</script>

<template>
  <g-copy>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span v-html="markDownCopy" />
  </g-copy>
</template>
